import { render, staticRenderFns } from "./EconomiaBateria.vue?vue&type=template&id=6a1db13d&scoped=true&"
import script from "./EconomiaBateria.vue?vue&type=script&setup=true&lang=js&"
export * from "./EconomiaBateria.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1db13d",
  null
  
)

export default component.exports